module.exports = __webpack_public_path__ + "static/media/Icon_Next.58141c15.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/ProductImage/icons/Icon_Next.svg
// module id = 1685
// module chunks = 0